"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectAll = void 0;
const selectAll = (options) => {
    const advancedFilterValue = [];
    return options.cols.reduce((advancedFilterValue, column) => {
        const groupData = [];
        column.groups.forEach(({ items }) => {
            groupData.push(...items.map(({ value }) => value));
        });
        return [...advancedFilterValue, ...groupData];
    }, advancedFilterValue);
};
exports.selectAll = selectAll;
//# sourceMappingURL=selectAll.js.map